    <template>
      <div class="clearfix rounded mt-4 pb-5 mx-auto">
        <div class="custom-loader-wrapper" v-if="download_loader">
            <div class="text-center">
                <span class="d-block max-450">{{download_text}}</span>
                <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                <p class="mt-5">Plesae click <a target="_blank" :href="$api_url+'/company/dashboard'">here</a> or below if you want to continue surfing the system.</p>
                <b-button  class="mb-1"  target="_blank"  :href="$api_url+'/company/dashboard'">Dashboard</b-button>
                <!-- <p class="mt-5">Plesae click <a target="_blank" href="#">here</a> or below if you want to continue surfing the system.</p> -->
                <!-- <b-button  class="mb-1"  target="_blank" href="#">Dashboard</b-button>                 -->
            </div>
        </div>

       <div class="row mt-4 no-margin">
            <div class="col-sm-12  company-form-box-title row">
                <div class="sm-6 d-flex align-items-center">Select Fiscal Year</div>

                <div class="sm-6 ml-4">
                    <b-form-select id="year" v-model="vr_fiscal_year" name="year" v-on:change="setfiscalyear()" required class="form-control">
                        <b-form-select-option v-for='fyear in fiscalYearArray' :value='fyear.fiscal_year' :key="fyear.id">
                            <!-- {{fyear.fiscal_year}} -->
                             {{ fyear.fiscal_year == '' ? 'Select Fiscal Year' : fyear.fiscal_year }} <!-- Mustafijur: 17-05-2026 -->
                        </b-form-select-option>
                    </b-form-select>
                </div>
            </div>
            <!-- table for all cost center data starts  -->
            <div class="col-sm-12 mt-4 px-0">
                <table class="table" v-show="payrun_table">
                    <thead>
                        <tr class="table-head">
                            <th scope="col" v-for="column in columns" :key="column.name">{{column.label}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- <tr class="table-row hover-bg" v-for="pr in payruns" :key="pr.id"> -->
                        <tr class="table-row hover-bg" v-for="(pr, ordering) in sortArrays(payruns)"  :key="ordering" >
                            <td class="align-middle">{{pr.month}}-{{pr.year}}</td>
                            <td class="align-middle">{{pr.fiscal_year}}</td>
                            <td class="align-middle" v-if="pr.status == 1">Approved</td>
                            <td class="align-middle" v-else>Not Approved</td>
                            <td>
                                <template v-if="pr.emp_ids == 'yes'">
                                    <b-dropdown id="dropdown-fields" text="Preview Report" variant="secondary" class="position-relative">
                                        <b-dropdown-item @click="getAccountJVReport(pr.id, pr.month,pr.year, 'jv')"><i class="fas fa-list"> </i>  Accounting JV Summary</b-dropdown-item>
                                        <b-dropdown-item @click="getAccountJVReport(pr.id, pr.month,pr.year, 'det')"><i class="fas fa-list"> </i> Accounting JV Detail</b-dropdown-item>
                                    </b-dropdown>
                                </template>
                                <template v-else>
                                    No employees are assigned to a cost center from this month's payroll
                                </template>
                            </td>
                            <td>
                                <template v-if="pr.emp_ids == 'yes'">
                                    <b-dropdown id="dropdown-fields" text="Download Report (Excel)" variant="secondary" class="position-relative">
                                        <b-dropdown-item @click="downloadAccountJVReport(pr.id, pr.month, pr.year, pr.fiscal_year, '1')"><i class="far fa-file-excel"> </i> Accounting JV Summary</b-dropdown-item>
                                        <b-dropdown-item @click="downloadAccountJVReport(pr.id, pr.month, pr.year, pr.fiscal_year, '2')"><i class="far fa-file-excel"> </i> Accounting JV Detail</b-dropdown-item>
                                        <b-dropdown-item @click="downloadAccountJVReport(pr.id, pr.month, pr.year, pr.fiscal_year, '3')"><i class="far fa-file-excel"> </i> Accounting JV Summary + Detail</b-dropdown-item>
                                    </b-dropdown>
                                </template>
                                <template v-else>
                                    No employee assigned to any cost center for this month's payroll
                                </template>
                            </td>
                        </tr>
                        <tr v-if="payruns.length == 0"><td :colspan=6>{{blankmsg}}</td></tr>
                    </tbody>
                </table>
            </div>
            <!-- table for all cost center data ends  -->
        </div>
        <!-- account jv report preview modal -->
        <div class="col-sm-12  px-0">
            <b-modal id="bv-modal-show-jv-report" size="lg" hide-footer title="Account JV Report">
                <p>{{company_name}}</p>
                <p>Accounting JV Report for the month of {{month_year}}</p>
                <jv-report :payrun_id="jvreports" :total_dc="total_dc"></jv-report>
            </b-modal>
        </div>
        <!-- detail report preview modal -->
        <div class="col-sm-12  px-0">
            <b-modal id="bv-modal-show-detail-report" size="lg" hide-footer title="Detailed Report">
                <p>{{company_name}}</p>
                <p>Accounting JV Detail Report for the month of {{month_year}}</p>
                <detail-report :payrun_id="jvreports" :total_dc="total_dc"></detail-report>
            </b-modal>
        </div>

      </div>
</template>

<script>
import JVReport from './JVReport.vue';
 export default{
        mounted() {
        },
        components: { JVReport },
        data(){
            let sortOrders = {};
            visible: false;
            let columns = [
                {label: 'Month - Year', name: 'month-year' },
                {label: 'Fiscal Year', name: 'fiscal_year'},
                {label: 'Payrun Status', name: 'payrun_status'},
                {label: 'Preview Report', name: 'preview_report'},
                {label: 'Download Excel', name: 'ddwnload_excel'},
            ];
            let reportColumns = [
                {label: 'GL Account Code', name: 'gl_account_code' },
                {label: 'GL Account Name', name: 'gl_account_name'},
                {label: 'Debit', name: 'Debit'},
                {label: 'Credit', name: 'Credit'},
            ];
            let detreportColumns = [
                {label: 'GL Account Name', name: 'GLAccountName'},
                {label: 'GL Account Code', name: 'GLAccountCode'},
                {label: 'Payroll Components', name:'payrollcomponents'},
                {label: 'Cost Center Name', name: 'cost_center_name'},
                {label: 'Cost Center Code', name: 'cost_center_code'},
                {label: 'Debit', name: 'Debit'},
                {label: 'Credit', name: 'Credit'},
            ];
            return {
                payrun_table: false,
                columns: columns,
                reportColumns: reportColumns,
                detreportColumns: detreportColumns,
                showoverlay:false,
                vr_fiscal_year : '',
                search:'',
                fiscal_year : '',
                fiscalYearArray: [],
                payruns: [],
                company_name: '',
                month_year:'',
                jvreports: [],
                detreports: [],
                sortKey: 'name',
                sortOrders: sortOrders,
                length : 10,
                pagination : {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},
                blankmsg : 'Fetching data..',
                download_loader: false,
                download_text: '',
                isShowModal: false,
                payrun_id:'',
                total_dc: [],
                cost_center_number: '',
            }
        },
        methods:{
            sortArrays(arrays) {
                return _.orderBy(arrays, 'ordering', 'desc');
            },
            handleChange(){
                //window.location.reload();
                //sessionStorage.setItem('key', index);
                this.tabKey += 1;
                if(this.$cookies.isKey("report_column_selected"))
                {
                    if(this.$cookies.get("report_column_selected") != null && this.$cookies.get("report_column_selected") != '')
                    {
                        if(Array.isArray(this.$cookies.get("report_column_selected")))
                        {
                            this.column_selected = this.$cookies.get("report_column_selected");
                        }
                        else
                        {
                            this.column_selected = this.$cookies.get("report_column_selected").split(',');
                        }
                    }
                }
                // End: Mustafijur : 8-24-25 Cookie
            },
            toggleModal() {
                this.isShowModal = !this.isShowModal;
            },
            onOver() {
                this.$refs.dropdown.visible = true;
            },
            onLeave() {
                this.$refs.dropdown.visible = false;
            },
            getfiscalyears: function()
            {
                axios.get(this.$api_url+'/getfiscal-years' , {
                        params: {
                        }
                }).then(function(response){
                    this.fiscalYearArray = response.data.all_year;
                    this.vr_fiscal_year = response.data.last_year;
                    if(response.data.first_year == 0)
                    {
                        payrun_table = false;
                    }
                    this.setfiscalyear();
                    console.log(this.vr_fiscal_year);
                    }.bind(this));
            },
            setfiscalyear: function()
            {
                let currentObj = this;
                var yr = this.vr_fiscal_year;
                if(yr)
                {
                    axios.get(this.$api_url+'/get-fiscal-year-data' , {
                            params: {
                                year: yr,
                            }
                    })
                    .then(function (response)
                    {
                        this.payrun_table = true;
                        this.payruns = response.data;
                    }.bind(this))
                    .catch(function (error)
                    {
                        currentObj.serverError(error);
                    });
                }
                else{
                    this.payrun_table = false;
                }
            },
            getAccountJVReport: function(id, month, year, fiscal_year, type)
            {
                let currentObj = this;
                var id = id;
                var report_type = type;
                this.$bvToast.toast('It might take a while', {
                                            title: `Info`,
                                            variant: 'info',
                                            solid: true
                                        });
                this.download_loader = true;
                this.download_text = 'Please hold tight. We are preparing report for you.';
                axios.get(this.$api_url+'/get-account-jv-report' , {
                        params: {
                            id: id,
                            month: month,
                            year: year,
                            fs_year: fiscal_year,
                            flag: 1,
                        }
                })
                .then(function (response)
                {
                    this.company_name = response.data.comapany_name;
                    this.month_year = month + '-' + year;
                    this.jvreports = response.data.report_data;
                    this.total_dc = response.data.total;
                    if(fiscal_year == 'jv')
                    {
                        this.$bvModal.show('bv-modal-show-jv-report');
                    }
                    else if(fiscal_year == 'det')
                    {
                        this.$bvModal.show('bv-modal-show-detail-report');
                    }
                    this.download_loader = false;
                    this.download_text = '';
                }.bind(this))
                .catch(function (error) //server error
                {
                    currentObj.serverError(error);
                });
            },
            getDetailReport: function(x,y)
            {
                let currentObj = this;
                var month = x;
                var year = y;
                axios.get(this.$api_url+'/get-account-jv-report' , {
                        params: {
                            month: month,
                            year: year,
                        }
                })
                .then(function (response)
                {
                    console.log(response.data);
                    this.$bvModal.show('bv-modal-show-detail-report');
                    this.company_name = response.data.comapany_name;
                    this.month_year = response.data.month + '-' + response.data.year;
                    this.detreports = response.data;

                }.bind(this))
                .catch(function (error) //server error
                {
                    currentObj.serverError(error);

                });
            },
            downloadAccountJVReport:function(id, month, year, fs_year, download_id)
            {
                let currentObj = this;
                this.$bvToast.toast('It might take a while', {
                                            title: `Info`,
                                            variant: 'info',
                                            solid: true
                                        });
                this.download_loader = true;
                const config = {

                    headers: { 'Content-Type': 'application/json; charset=utf-8', },
                    responseType: 'blob',
                }
                this.download_text = 'Please hold tight. We are exporting the template for you.';
                axios.get(this.$api_url+'/accountjv-report-download', {
                        params: {
                            id: id,
                            month: month,
                            year: year,
                            fs_year: fs_year,
                            download_id: download_id

                        },
                        headers: { 'Content-Type': 'application/json; charset=utf-8', },
                        responseType: 'blob',
                })
                .then(function (response)
                {

                    if(response.data.type =='application/json')
                    {
                        let file = new Blob([response.data], {type: 'application/json'}); /* if you use different error message just change the name instead of  'error_msg' */
                        const cast = Promise.resolve(file.text());
                        cast.then((value) => {
                        currentObj.$bvToast.toast("No data found", {title: 'Error',variant: 'danger',solid: true});
                        });
                        this.download_loader = false;
                        this.download_text = '';
                    }
                    else
                    {

                        this.global_download_file_content(response);
                        this.download_loader = false;
                        this.download_text = '';
                    }


                }.bind(this))
                .catch(function (error) //server error
                {
                    this.serverError(error);
                });
            },
            download_file(fileURL)
            {
                if(!this.checkNet()) return false;

                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },
            getCurrentFiscalYear: function()
            {
                axios.get(this.$api_url+'/get_current_fiscal_year' , {
                }).then(function(response){
                    this.vr_fiscal_year =  response.data.fiscal_year;

                }.bind(this));
            },
            getCostCenterNumber:function()
            {
                axios.get(this.$api_url+'/get_total_cost_center' , {
                }).then(function(response){
                    this.cost_center_number =  response.data;

                }.bind(this));
            }
        },
        created: function(){
            this.getfiscalyears();
            // this.getCostCenterNumber();
        },
        computed:
        {
            filteredData()
            {
                let filtered_list = this.jvreports;
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});

                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";
                }

                let sortKey = this.sortKey;
                let order = this.sortOrders[sortKey] || 1;
                if (sortKey)
                {
                    filtered_list = filtered_list.slice().sort((a, b) =>
                    {
                        let index = this.getIndex(this.reportColumns, 'name', sortKey);
                        a = String(a[sortKey]).toLowerCase();
                        b = String(b[sortKey]).toLowerCase();
                        return (a === b ? 0 : a > b ? 1 : -1) * order;
                    });
                }

                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },
        }
    }
</script>
